import api from '../../utils/api';
import router from '../../router';

// initial state
const state = {
    rootId: 0,
    id: 0,
    name: '',
    items: [],

    parentIds: [],
    parentNames: [],
    parentItems: []
};

// mutations
const mutations = {
    id(state, id) {
        state.id = id;
    },
    name(state, name) {
        state.name = name;
    },
    items(state, items) {
        state.items = items;
    },
    pustParent(state) {
        state.parentIds.push(state.id);
        state.parentNames.push(state.name);
        state.parentItems.push(state.items);
    },
    popParent(state, index) {
        state.id = state.parentIds[index];
        state.name = state.parentNames[index];
        state.items = state.parentItems[index];

        const length = state.parentIds.length - index;
        state.parentIds.splice(index, length);
        state.parentNames.splice(index, length);
        state.parentItems.splice(index, length);
    }
};

// getters
const getters = {
    showUp(state) {
        return state.rootId !== state.id;
    },
    showBack(state) {
        return state.rootId === state.id;
    }
};

// actions
const actions = {
    resolveParentGroup(store, id) {
        const index = store.state.parentIds.indexOf(id);
        if (index !== -1) {
            store.commit('popParent', index);
        }
    },
    openGroup(store, item) {
        if (store.state.rootId !== item.id) {
            store.commit('pustParent');
        }
        api.get(`/api/catalog/getItems/${item.id}`).then(function(response) {
            store.commit('id', item.id);
            store.commit('name', item.name);
            store.commit('items', response.body);
            router.push({
                name: 'catalog',
                params: { id: item.id }
            });
        });
    },
    up(store) {
        router.push({
            name: 'catalog',
            params: { id: store.state.parentIds[store.state.parentIds.length - 1] }
        });
    },
    back() {
        router.push({
            name: 'dashboard'
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/catalog.js